/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Popconfirm, Checkbox, Space, Card, Table, Input, Button, Tooltip } from "antd";
import { DeleteOutlined, PlusCircleOutlined, SyncOutlined, } from "@ant-design/icons";
import ShowBusiness from "./ShowBusiness";
import EditBusiness from "./EditBusiness";
import AddSubDomainModal from "./AddSubDomainModal";
import DeleteSubDomainModal from "./DeleteSubDomainModal";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import config from "../../config";

const { Search } = Input;

export default function Businesses() {
  const { auth, business, getBusinesses, deleteSubDomains, addSubDomains, filterBussiness, getBusinessBytoken, updateOneBusiness, getNewWhitelabeles, deleteBusiness, } = usePersistedStore();
  const general = useGeneralStore();
  const [filterText, setFilterText] = useState("");
  const [addSubDomainModalOpen, setAddSubDomainModalOpen] = useState(false);
  const [deleteSubDomainModalOpen, setDeleteSubDomainModalOpen] = useState(false);
  const [selectedDomainBusiness, setSelectedDomainBusiness] = useState(null);

  const userResources = auth.userInfo?.Resources || [];

  const isBaseUrlEqualsFrontCore = config.apiUrls().includes(config.api.test);

  // Delete Business
  const hasDeleteBusinessAccess =
    isBaseUrlEqualsFrontCore ||
    (userResources.includes("BusinessesManagment") &&
      userResources.includes("DeleteBusiness"));

  // Edit Business
  const hasEditBusinessAccess =
    isBaseUrlEqualsFrontCore ||
    (userResources.includes("BusinessesManagment") &&
      userResources.includes("BusinessAdmin") &&
      userResources.includes("UpdateBusiness"));

  // Show Business
  const hasShowBusinessAccess =
    isBaseUrlEqualsFrontCore ||
    (userResources.includes("BusinessAdmin") &&
      userResources.includes("access_to_sub_businesses") &&
      userResources.includes("UserBusinessReport") &&
      userResources.includes("BusinessRenewalReport") &&
      userResources.includes("BusinessApp"));

  // Sync Business
  const hasSyncBusinessAccess =
    isBaseUrlEqualsFrontCore ||
    (userResources.includes("BusinessesManagment") &&
      userResources.includes("SyncBusinesses"));

  // CDN Access
  const hasCDNAccess =
    isBaseUrlEqualsFrontCore ||
    userResources.includes("CDN");

  const data = business.businesses.filtered;
  const loading = business.businesses.loading;
  const businesses = business.businesses.all;
  const isError = business.businesses.isError;

  const testDomains = ["testtools.bimeh.com", "toolsdemo.bimeh.com", "localhost:3002",];

  const isTestDomain = testDomains.includes(window.location.host);

  const getAllBusinussArray = (businesses) => Object.keys(businesses).map((token) => businesses[token]);

  const allBusinussArray = getAllBusinussArray(businesses);

  useEffect(() => {
    getBusinesses();
  }, []);

  useEffect(() => {
    if (isError) {
      general.ToggleBusinessEditModal();
    }
  }, [isError]);

  const columns = [
    {
      title: "نام شریک تجاری",
      dataIndex: "name",
      key: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "آدرس سایت",
      dataIndex: "domain",
      key: "domain",
      render: (text) => {
        if (text) {
          text = text.split(",");

          return (
            <ul>
              {text.map((item, index) => {
                if (item !== "") {
                  return (
                    <li key={index}>
                      <a
                        href={`https://${item}`}
                        style={{ cursor: "pointer" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item}
                      </a>
                    </li>
                  );
                }

                return null;
              })}
            </ul>
          );
        }

        return null;
      },
    },
    {
      title: "توکن",
      dataIndex: "token",
      key: "token",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "نوع",
      dataIndex: "type",
      key: "type",
      width: "50px",
      render: (_, record) =>
        record.type === 2 ? (
          <span>وایت لیبل</span>
        ) : (
          record.type === 1 && <span>سازمان اصلی</span>
        ),
    },
    {
      title: "رنگ اصلی",
      dataIndex: "primaryColor",
      key: "primaryColor",
      width: "50px",
      render: (_, record) =>
        record.type === 2 && (
          <span
            style={{
              width: 20,
              height: 20,
              backgroundColor: record.primaryColor,
              position: "absolute",
            }}
          />
        ),
    },
    {
      title: "وضعیت فعلی",
      dataIndex: "enable",
      key: "enable",
      width: "20px",
      render: (_, record) => (
        <Checkbox disabled checked={record.enable}>
          {record.enable}
        </Checkbox>
      ),
    },
    {
      title: "",
      dataIndex: "operation",
      key: "operation",

      render: (_, record) =>
        allBusinussArray.length >= 1 && (
          <Space size="middle">
            {/* DELETE BUSINESS */}
            {hasDeleteBusinessAccess && (
              <Popconfirm
                title="آیا از حذف شریک تجاری اطمینان دارید؟"
                onConfirm={() => {
                  deleteBusiness(record);
                }}
                okText="تایید"
                cancelText="انصراف"
              >
                <button
                  type="danger"
                  className="btn btn-danger w-xs btn-sm waves-effect waves-light"
                >
                  <i className="fas fa-minus font-size-16 align-middle mr-2"></i>
                  حذف
                </button>
              </Popconfirm>
            )}

            {/* EDIT BUSINESS */}
            {(record.type === 2 || record.id === 13 || isTestDomain) &&
              hasEditBusinessAccess && (
                <button
                  type="dashed"
                  className="btn btn-warning w-xs btn-sm waves-effect waves-light"
                  onClick={() => {
                    getBusinessBytoken(record.token, "edit");
                    general.ToggleBusinessNewEditModal();
                  }}
                  style={{ display: "flex" }}
                >
                  <i className="far fa-edit font-size-16 align-middle mr-2"></i>
                  ویرایش
                </button>
              )}

            {/* SHOW BUSINESS */}
            {hasShowBusinessAccess && (
              <button
                type="primary"
                className="btn btn-primary w-xs btn-sm waves-effect waves-light"
                onClick={() => {
                  general.ToggleBusinessShowModal();
                  getBusinessBytoken(record.token, "edit");
                }}
              >
                <i className="far fa-file-alt font-size-16 align-middle mr-2"></i>
                نمایش
              </button>
            )}

            {/* SYNC ONE BUSINESS */}
            {hasSyncBusinessAccess && (
              <Tooltip trigger="hover" title="همگام‌سازی بیزینس">
                <Button
                  type="primary"
                  icon={<SyncOutlined />}
                  onClick={() => {
                    updateOneBusiness(record.token);
                    getBusinesses();
                  }}
                />
              </Tooltip>
            )}

            {/* ADD SUBDOMAIN */}
            {hasCDNAccess && (
              <Tooltip trigger="hover" title="افزودن ساب‌دامین">
                <Button
                  className="sub-domain-buttons"
                  icon={<PlusCircleOutlined />}
                  type="primary"
                  onClick={() => {
                    setAddSubDomainModalOpen(true);
                    setSelectedDomainBusiness(record);
                  }}
                >
                  <span className="btn-text"></span>
                </Button>
              </Tooltip>
            )}

            {/* DELETE SUBDOMAIN */}
            {hasCDNAccess && (
              <Tooltip trigger="hover" title="حذف ساب‌دامین">
                <Button
                  className="sub-domain-buttons"
                  icon={<DeleteOutlined />}
                  danger
                  onClick={() => {
                    setDeleteSubDomainModalOpen(true);
                    setSelectedDomainBusiness(record);
                  }}
                >
                  <span className="btn-text"></span>
                </Button>
              </Tooltip>
            )}
          </Space>
        ),
    },
  ];

  const handleSearch = (e) => {
    setFilterText(e.target.value);

    allBusinussArray &&
      filterBussiness({
        value: e.target.value,
        all: allBusinussArray,
      });
  };

  return (
    <Card>
      <Search
        className="table-search"
        placeholder=" جستجو بر اساس نام شریک تجاری، آدرس سایت"
        onChange={handleSearch}
      />

      {/* SYNC ALL BUSINESSES */}
      {hasSyncBusinessAccess && (
        <div style={{ float: "left" }}>
          <button
            type="primary"
            className="btn btn-primary waves-effect waves-light"
            onClick={getNewWhitelabeles}
          >
            <i className="fas fa-sync-alt font-size-14 align-middle mr-2"></i>
            بیزینس های جدید
          </button>
        </div>
      )}

      <Table
        className="user-table"
        bordered
        columns={columns}
        loading={loading}
        dataSource={filterText ? data : allBusinussArray}
        scroll={true}
        rowKey="token"
      />

      <ShowBusiness />

      <EditBusiness />

      <AddSubDomainModal
        open={addSubDomainModalOpen}
        setOpen={setAddSubDomainModalOpen}
        selectedBusiness={selectedDomainBusiness}
        onSubmit={addSubDomains}
      />

      <DeleteSubDomainModal
        open={deleteSubDomainModalOpen}
        setOpen={setDeleteSubDomainModalOpen}
        selectedBusiness={selectedDomainBusiness}
        onSubmit={deleteSubDomains}
      />
    </Card>
  );
}